class ServicoChamados {
    constructor({ api }) {
        this.api = api;
        this.cancelToken = null;
    }

    obterChamados({ idUsuario, contextoId, estado, offset = 0, limit = 0 }) {
        return this.api
            .get(
                `/api/ticket?contextoId=${contextoId}&idUsuario=${idUsuario}&estado=${estado}&offset=${offset}&limit=${limit}`,
            )
            .then((response) => response.data);
    }

    obterChamadosAbertos({ idUsuario, contextoId, offset, limit }) {
        return this.obterChamados({
            idUsuario,
            contextoId,
            estado: "aberto",
            offset,
            limit,
        });
    }

    obterChamadosFechados({ idUsuario, contextoId, offset, limit }) {
        return this.obterChamados({
            idUsuario,
            contextoId,
            estado: "fechado",
            offset,
            limit,
        });
    }

    /**
     * Fetches tickets (chamados) for a given user with pagination and full-text search.
     *
     * Cancels any ongoing request before initiating a new one.
     *
     * @param {Object} params - The parameters for fetching tickets.
     * @param {number|string} params.idUsuario - The ID of the user whose tickets are to be fetched.
     * @param {number} params.offset - The offset for pagination.
     * @param {number} params.limit - The maximum number of tickets to fetch.
     * @param {string} params.texto - The full-text search query.
     * @returns {Promise<Object>} A promise that resolves to the response data containing the tickets.
     * @throws {RequestCancelled} If the request is cancelled, the promise will throw an error of type RequestCancelled.
     */
    buscarChamados({ idUsuario, contextoId, offset, limit, texto }) {
        if (this.cancelToken) {
            this.api.cancelGetRequest(this.cancelToken);
        }

        this.cancelToken = this.api.createCancelToken();

        return this.api
            .get(
                `/api/ticket/fulltext?idUsuario=${idUsuario}&contextoId=${contextoId}&offset=${offset}&limit=${limit}&texto=${texto}`,
                this.cancelToken,
            )
            .then((response) => response.data);
    }

    obterChamado({ contextoId, idTicket }) {
        return this.api
            .get(`/api/ticket/${contextoId}/${idTicket}`)
            .then((response) => response.data);
    }

    enviarResposta({ contextoId, idTicket, resposta }) {
        const headers = {
            "Content-Type": "application/json",
        };

        return this.api
            .post(`/api/ticket/${contextoId}/${idTicket}`, resposta, {
                headers,
            })
            .then((response) => response.data);
    }

    obterNumChamadosNaoVisualizados({ idUsuario, contextoId, estado }) {
        return this.api.get(
            `/api/visualization/ticket?idUsuario=${idUsuario}&estado=${estado}&contextoId=${contextoId}`,
        );
    }

    visualizarArtigo({ idUsuario, ticketId, articleId, contextoId }) {
        const articleVisualization = {
            ticketId,
            articleId,
            seen: true,
            contextoId,
        };
        return this.api
            .post(
                `/api/visualization/article?idUsuario=${idUsuario}`,
                articleVisualization,
            )
            .then((response) => response.data);
    }
}

export default ServicoChamados;
